import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="border-t border-line bg-bg-2/40">
      <div className="mx-auto max-w-6xl px-6 py-14">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr] items-start">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <img src="/logo.png" alt="" className="h-9 w-9 rounded-lg" />
              <span className="font-bold tracking-[0.15em] text-lg">ARABISE</span>
            </div>
            <p className="text-sm text-fg-2 leading-relaxed max-w-sm">
              GCSE Arabic revision, done right. Quizzes, sentences, and streaks — all in one place.
            </p>
          </div>

          <nav aria-label="Footer navigation" className="flex flex-col gap-2">
            <div className="text-xs uppercase tracking-widest text-fg-3 mb-2">Resources</div>
            <Link  to="/terms"    className="text-sm text-fg-2 hover:text-fg">Terms of Service</Link>
            <Link  to="/privacy"  className="text-sm text-fg-2 hover:text-fg">Privacy Policy</Link>
            <a href="mailto:support@arabise.co.uk" className="text-sm text-fg-2 hover:text-fg">Contact</a>
          </nav>

          <div className="flex md:justify-end">
            <a
              href="https://vultruon.channelkhan.com"
              target="_blank" rel="noopener"
              className="inline-flex items-center gap-3 group"
              aria-label="Made by Vultruon"
            >
              <span className="text-xs uppercase tracking-widest text-fg-3 group-hover:text-fg-2 transition-colors">
                Made by
              </span>
              <span className="inline-flex bg-white rounded-xl p-1.5">
                <img src="/vultruon.png" alt="Vultruon" className="h-9 rounded-md" />
              </span>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-line flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-fg-3">
          <span>© 2026 Arabise. Made with care in the UK.</span>
          <span>Arabise is built for GCSE students. Not affiliated with any exam board.</span>
        </div>
      </div>
    </footer>
  );
}
